<template>
  <div :class="{ 'pk-input': true, 'pk-input--error': error, 'pk-input--inline': inline }">
    <div :class="{
      'pk-input__input-container': true,
      'pk-input--error__input-container': error,
      'pk-input--inline__input-container': inline,
      'pk-input__input-container--filled': (error || ![null, undefined, ''].includes(value))
    }">
      <the-mask v-if="mask"
        ref="input"
        :value="value"
        :type="returnType"
        :maxlength="maxlength"
        :autocomplete="autocomplete"
        :mask="mask"
        :disabled="disabled"
        :tokens="mask ? tokens : undefined"
        @input="evt => $emit('input', evt.target ? evt.target.value : evt)"
        required
      />
      <input v-else
        ref="input"
        :value="value"
        :type="returnType"
        :maxlength="maxlength"
        :autocomplete="autocomplete"
        :mask="mask"
        :disabled="disabled"
        :tokens="mask ? tokens : undefined"
        @input="evt => $emit('input', evt.target ? evt.target.value : evt)"
        required
      />
      <label>{{ placeholder }}</label>

      <span class="pk-input__icons">
        <EyeIcon
          v-if="type === 'password'"
          :fill="showPassword ? '#606568' : '#A217AB'"
          @click.native="showPassword = !showPassword"
        />
        <alert-icon v-if="error" :title="errorText" />
      </span>
    </div>
    <error-text v-if="!inline"></error-text>
  </div>
</template>

<script>
import { tokens } from 'vue-the-mask'

export default {
  name: 'pk-input',
  props: {
    placeholder: String,
    type: String,
    error: Boolean,
    errorText: String,
    maxlength: Number,
    autocomplete: String,
    autofocus: Boolean,
    value: String,
    disabled: Boolean,
    inline: Boolean,
    mask: String
  },
  data () {
    return {
      showPassword: false
    }
  },
  watch: {
    value(val) {
      this.value = val
    }
  },
  computed: {
    tokens() {
      return Object.assign(tokens, {
        'N': {
          pattern: /[a-zA-Z ]/,
          transform: v => v.toLocaleUpperCase()
        }
      })
    },
    returnType() {
      return this.showPassword ? 'text' : this.type
    }
  },
  mounted() {
    if (this.autofocus) {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss">
.pk-input {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: .25rem;
  flex-grow: 1;

  &__input-container {
    display: flex;
    align-items: center;
    position: relative;
    transition: border-color 0.2s ease, background-color 0.2s ease;
    padding-top: .6rem;
    margin-bottom: .25rem;
    outline: none;

    & > label {
      position: absolute;
      top: 20px;
      font-family: Nunito;
      font-style: normal;
      font-weight: normal;
      font-size: 1.1rem;
      color: $input-text-color--empty;
      transition: all 0.1s linear;
      z-index: 1;
    }
    &--filled > label,
    & > input:-webkit-autofill + label {
      top: 0;
      font-size: 11px;
      line-height: 16px;
      color: $input-text-color;
      transition: all 0.1s linear;
    }

    & > input {
      appearance: none;
      padding: 1rem;
      padding-left: 0;
      padding-right: 0;
      font-size: 1.1rem;
      width: 100%;
      height: inherit;
      outline: none;
      border: none;
      min-width: unset;
      color: $input-text-color;
      z-index: 2;

      border-bottom: $input-border;
      background-color: $input-background-color;

      &:focus {
        border-bottom: $input-border--focus
      }
    }

    & > .alert-icon {
      position: absolute;
      display: block;
      width: 1.4rem;
      right: 0.6rem;
      opacity: 0;
      transition: opacity 0.2s ease;
    }
  }

  &__icons {
    display: flex;
    position: absolute;
    align-items: center;
    right: 0;
    z-index: 5;
    >* {
      margin-left: 1rem;
    }
    .eye-icon {
      cursor: pointer;
    }
  }

  & > .error-text.active {
    margin-bottom: 0;
    margin-left: 1rem;
    font-size: 12px;
  }

  &--error {
    &__input-container {

      & > label {
        color: $error-color;
      }
      & > input {
        color: $error-color;
        font-weight: 600;
        border-color: $error-color;
        &:focus {
          border-color: $error-color;
        }
      }

      & > .alert-icon {
        opacity: 1;
      }
    }
  }

  @media screen and (min-width: 568px) {
    &--inline__input-container {
      border-right: none;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }

  @media only screen and (min-width: 1200px) {
    margin-bottom: 8px;

    &__input-container {
      margin-bottom: 8px;
    }
  }

  &--inline {
    margin-bottom: 0;

    &__input-container {
      margin-bottom: 0px;
    }
  }
}
</style>
